import { render, staticRenderFns } from "./SharingTypeSelect.vue?vue&type=template&id=019307e6"
import script from "./SharingTypeSelect.vue?vue&type=script&lang=js"
export * from "./SharingTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports